export const hasData = (value?: any): boolean => {
  if (value === null || typeof value === "undefined") return false;

  if (typeof value === "string") {
    const lowerValue = value.trim().toLowerCase();

    if (lowerValue === "undefined" || lowerValue === "null") return false;

    return !!value.length;
  }

  if (Array.isArray(value)) return !!value.length;

  if (typeof value === "boolean") return true;

  if (typeof value === "object") {
    if (value instanceof Date) return true;

    return !!Object?.values(value || {}).filter((value) => hasData(value)).length;
  }

  return true;
};
